import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { consumerDetailsObject } from 'app/models/ConsumerDetailsObject/ConsumerDetailsObject';
import { HttpTestService } from 'app/services/http.service';
import { AppSettings } from '../../config/settings/app-settings';
import { documentModel } from '../../models/documentUpload/doc.model';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { DocumentTypeAll } from 'app/models/documentType/documentType';
import { Constants } from 'app/config/settings/constants';
import { AppComponent } from 'app/app.component';

@Component({
  selector: 'app-transaction-details',
  templateUrl: './transaction-details.component.html',
  styleUrls: ['./transaction-details.component.css']
})

export class TransactionDetailsComponent implements OnInit {
  public serviceOn: boolean = false;
  public errorMsg: string = "";
  public successMsg: string = "";
  public user: any;
  public isHideTable: boolean = true;
  public emdYes: boolean = false;
  public netYes: boolean = false;
  public emdNull: boolean = false;
  public isOk: boolean = true;
  public isCross: boolean = true;
  public isOkEmd: boolean = true;
  public isCrossEmd: boolean = true;
  public isOkTechSurvey: boolean = true;
  public isCrossTechSurvey: boolean = true;
  public isOkQutationGenrt: boolean = true;
  public isCrossQutationGenrt: boolean = true;
  public isOkPayment: boolean = true;
  public isCrossPayment: boolean = true;
  public isOkWorkStatus: boolean = true;
  public isCrossWorkStatus: boolean = true;
  public isOkWorkExe: boolean = true;
  public isCrossWorkExe: boolean = true;
  public isOkEnergised: boolean = true;
  public isCrossEnergised: boolean = true;
  public isOkHoldDocmnt: boolean = true;
  public isWarnHoldDocmnt: boolean = true;
  public hideSelectedTransID: boolean = false;
  public hideTransID: boolean = true;
  public popupopen: boolean = true;
  public isDisableDownldOffer: boolean = false;
  public bpIdentificationCategory: any;
  public bpIdentificationCategorySapCode: any;
  public verifiedId: boolean = false;
  public verifiedOwn: boolean = false;
  public documentTypeForOtherId: boolean = true;
  public documentTypeForOtherOwn: boolean = true;
  public documentTypeForOtherAuth: boolean = true;
  public isProofID: boolean = true;
  public isProofOwn: boolean = true;
  public isProofAuth: boolean = true;
  documentListForId: any;
  documentListForOwn: any;
  documentListForAuth: any;
  public card1Length: string;
  public card2Length: string;
  public card3Length: string;
  documentTypeModel: DocumentTypeAll = new DocumentTypeAll();

  public consumerDetails = new consumerDetailsObject();
  public consumerDetailsObject: consumerDetailsObject;
  public documentModel: documentModel = new documentModel;
  public selectedTransactionId: any;
  public transactionId: any;
  public transcId: string;
  public transctionDetails: any;
  public multiple: any;
  selectedFile: File = null;
  selectedOwenershipFile: File = null
  selectedAuthorizationDocFile: File = null
  headers: Headers;
  public isHiddenOwnerShip: boolean;
  public isAuthorization: boolean;
  public isDisable: boolean;
  public isHidden: boolean;
  public suppliedId: number;
  public isLoaded: boolean;
  public isShow: boolean;
  public isDocUpload: boolean;
  public isProof: boolean;
  public isOwnership: boolean;
  public isAuthorize: boolean;

  public isProofUpload: boolean = true;
  public isOwnershipUpload: boolean = true;
  public isAuthorizeUpload: boolean = true;

  public proofOfUploadFile: any;
  public ownershipFile: any;
  public authorizationFile: any;
  public isHideIdentity: boolean = false;
  public isHideOwnership: boolean = false;
  public isHideAuthorization: boolean = false;
  public isSubmitDoc: boolean = false;
  public payEMDBtn: boolean = true;
  public payDemand: boolean = false;
  public isWorkInProgress: boolean = false;
  public payEmdAmnt: string;
  public payNetAmnt: string;
  public emdAmountNo: number;

  public errorMsgIdentity: string = "";
  public successMsgIdentity: string = "";
  public duplicateMsgForIdentity: string = "";

  public errorMsgOwnershipMsg: string = "";
  public successMsgOwnershipMsg: string = "";
  public duplicateMsgForOwnership: string = "";

  public errorAuthMsg: string = "";
  public successAuthMsg: string = "";
  public duplicateMsgForAuth: string = "";

  public isProofOfIdentityMsg: boolean = true;
  public isProofOfOwnershipMsg: boolean = true;
  public isAuthMsg: boolean = true;

  public isDuplicateMsgForOwnership: boolean = true;
  public isDuplicateMsgForAuth: boolean = true;

  public isHideSuccessMsgForIdentity: boolean = true;
  public disableUpdateDocBtn: boolean = false;

  documentList: any;
  public noOfUploadDoc: number;
  public initiatePaymentData: any;
  public netAmount: number;
  public noOfDocUpld: number;
  public isWorkInProgressTechSur: boolean = true;
  public isWorkInProEnersiged: boolean = true;
  public isWorkInProWorkCom: boolean = true;
  public isWorkInProWorkStart: boolean = true;
  public isWorkInProConPay: boolean = true;
  public isWorkInProOfferGen: boolean = true;
  public isHideSurvey: boolean = true;
  public isHideExecution: boolean = true;
  public isHideApplication: boolean = false;
  public isRedCross: boolean = true;
  public isHideExecutionStage: boolean = true;
  public isPaymentTermsConditn: boolean = true;
  public isPaymentTermsForPayDemand: boolean = true;
  public disableButton: boolean = true;
  public isDisableCB: boolean = true;
  public isChecked: boolean = false;
  public isShowTermsCondnts: boolean = false;
  public isTermsCond: boolean = true;
  public regeonalBroadCast: any = [];

  public consumerBasicPostData = {
    "identificationDoc": null,
    "ownershipDoc": null,
    "authorizationDoc": null
  }

  public trasactionList = [{
    "mobileNumber": String,
    "password": String,
    "transactionId": String,
    "status": String
  }]
  // transactionIdd: { "mobileNumber": StringConstructor; "password": StringConstructor; "transactionId": StringConstructor; "status": StringConstructor; };

  downloadOfferBlocked: boolean = false;
  msgToShowWhileDownloadFile: string = Constants.msgToShowWhileDownloadFile;

  constructor(private router: Router,
    private route: ActivatedRoute,
    public http: HttpTestService,
    private _http: HttpClient,
    private appComponent: AppComponent) {
    this.headers = new Headers();
    this.headers.set('Content-Type', 'multipart/form-data');
    this.isAuthorization = true;
    this.isHiddenOwnerShip = true;
    this.isHidden = true;
    this.isDisable = true;
    this.isShow = true;
    this.isProof = true;
    this.isOwnership = true;
    this.isAuthorize = true;
  }

  ngOnInit() {
    var self = this;
    self.http.getDocumentTypeForIdInfo().subscribe(
      (data) => {
        self.documentListForId = data;
      },
      (error) => {
      },
      () => {
      }
    )
    self.http.getDocumentTypeForOwnInfo().subscribe(
      (data) => {
        self.documentListForOwn = data;
      },
      (error) => {
      },
      () => {
      }
    )
    self.http.getDocumentTypeForAuthInfo().subscribe(
      (data) => {
        self.documentListForAuth = data;
      },
      (error) => {
      },
      () => {
      }
    )
    this.route.queryParams.subscribe(params => {
      this.user = JSON.parse(params["user"]);
    });
    this.trasactionList = this.user;
    let transaction = this.trasactionList[0];
    this.selectedTransactionId = transaction["transactionId"];
    this.getTransactionDetails(this.selectedTransactionId);
    this.retriveUplodedDocumentDetails();
  }

  onSelectCategory(prefixName) {
    var self = this;
    this.documentTypeModel.bpIdentificationCategory1 = prefixName;
    if (prefixName == 'Others') {
      this.documentTypeForOtherId = false;
    } else {
      this.documentTypeForOtherId = true;
    }
    self.http.getDocumentTypeForIdInfo().subscribe(
      (data) => {
        //    self.documentListForId = data;
        data.forEach(element => {
          if (element.bpIdentificationCategory == prefixName) {
            this.card1Length = element.documentReferNoMaxLength;
          }
        });
      },
      (error) => {
        // self.errorMsg = error;
      });
  }

  logout() {
    this.appComponent.getBroadCastForPaymentNSC(null, null);
    this.router.navigate(["nsc"],{ skipLocationChange: true });
  }

  public postPaymentData = {
    "applicationNumber": null,
    "paymentType": null,
    "amount": null,
    "paymentChannelId": null,
    "gateway":null
  }

  showTermsCondtn() {
    if (this.isChecked) {
      this.disableButton = true;
      this.isShowTermsCondnts = false;
    } else {
      if (this.payEmdAmnt != '0.0' && this.payEmdAmnt != '0.00' && this.payEmdAmnt != '0') {
        this.disableButton = false;
      } else {
        this.disableButton = true;
      }
      this.isShowTermsCondnts = true;
    }
  }

  openTermsCondForPayDemand() {
    this.isPaymentTermsForPayDemand = false;
  }

  cancelTermsForPayDemand() {
    this.isPaymentTermsForPayDemand = true;
  }

  openTermsCondition() {
    this.isTermsCond = false;
  }

  cancelTermsCondtn() {
    this.isTermsCond = true;
  }

  onSelectCategoryForOwn(own) {
    var self = this;
    this.documentTypeModel.bpIdentificationCategory2 = own;
    if (own == 'Others') {
      this.documentTypeForOtherOwn = false;
    } else {
      this.documentTypeForOtherOwn = true;
    }
    self.http.getDocumentTypeForOwnInfo().subscribe(
      (data) => {
        data.forEach(element => {
          if (element.bpIdentificationCategory == own) {
            this.card2Length = element.documentReferNoMaxLength;
          }
        });
      },
      (error) => {
        // self.errorMsg = error;
      });
  }

  onSelectCategoryForAuth(auth) {
    var self = this;
    this.documentTypeModel.bpIdentificationCategory3 = auth;
    if (auth == 'Others') {
      this.documentTypeForOtherAuth = false;
    } else {
      this.documentTypeForOtherAuth = true;
    }
    self.http.getDocumentTypeForAuthInfo().subscribe(
      (data) => {
        data.forEach(element => {
          if (element.bpIdentificationCategory == auth) {
            this.card3Length = element.documentReferNoMaxLength;
          }
        });
      },
      (error) => {
        // self.errorMsg = error;
      });
  }

  isDisabledID(): boolean {
    if ((this.documentTypeModel.card1 == null) || (this.documentTypeModel.card1 == "")
      || (this.documentTypeModel.card1 == "undefined") || (this.isProof == true)
      || (this.documentTypeModel.bpIdentificationCategory1 == null)) {
      this.isProofID = true;
    } else {
      this.isProofID = false;
    }
    // this.isProof = true;
    return this.isProofID;
  }

  isDisabledOwn(): boolean {
    if ((this.documentTypeModel.card2 == null) || (this.documentTypeModel.card2 == "")
      || (this.documentTypeModel.card2 == "undefined") || (this.isOwnership == true)
      || (this.documentTypeModel.bpIdentificationCategory2 == null)) {
      this.isProofOwn = true;
    } else {
      this.isProofOwn = false;
    }
    // this.isProof = true;
    return this.isProofOwn;
  }

  isDisabledAuth(): boolean {
    if ((this.documentTypeModel.card3 == null) || (this.documentTypeModel.card3 == "")
      || (this.documentTypeModel.card3 == "undefined") || (this.isAuthorize == true)
      || (this.documentTypeModel.bpIdentificationCategory3 == null)) {
      this.isProofAuth = true;
    } else {
      this.isProofAuth = false;
    }
    // this.isProof = true;
    return this.isProofAuth;
  }

  getTransactionDetails = function (transactionId) {
    var self = this;
    this.transcId = transactionId;
    this.isOkQutationGenrt = true;
    this.isWorkInProOfferGen = true;
    this.isWarnHoldDocmnt = true;

    self.http.getTransactionDatatable(this.transcId).subscribe(
      (data: consumerDetailsObject) => {
        this.consumerDetails = data;
        this.noOfUploadDoc = this.consumerDetails.noOfUploadDoc;
        this.noOfDocUpld = this.noOfUploadDoc;
        this.payEmdAmnt = this.consumerDetails.emdAmount;
        this.payNetAmnt = this.consumerDetails.netAmount;

        this.emdAmountNo = parseInt(this.payEmdAmnt);
        if (this.emdAmountNo >= 500000) {
          this.disableButton = true;
        }

        if (this.noOfUploadDoc == 2 || this.noOfUploadDoc == 3) {
          this.disableUpdateDocBtn = true;
          this.isWarnHoldDocmnt = true;
        } else {
          this.disableUpdateDocBtn = false;
          this.isWarnHoldDocmnt = false;
        }


        if (this.consumerDetails.appReceived == 'Yes') {
          this.isOk = false;
          this.isCross = true;
        } else {
          this.isOk = true;
          this.isCross = false;
        }

        if (this.consumerDetails.emdPaid == 'No') {
          this.isWorkInProgress = false;
          this.isOkEmd = true;
          //this.isCrossEmd = false;
          this.payEMDBtn = false;
          this.isSubmitDoc = false;
        }

        if (this.consumerDetails.emdPaid == 'Yes' && this.consumerDetails.techSurvey == 'No') {
          // alert("ok111")
          this.isOkEmd = false;
          //this.isCrossEmd = true;
          this.payEMDBtn = true;
          this.isSubmitDoc = true;
          this.isCrossTechSurvey = true;
          this.isWorkInProgressTechSur = false;
          this.isCrossQutationGenrt = true;
          this.isDisableDownldOffer = true;
          this.isWorkInProgress = true;
        } else if (this.consumerDetails.emdPaid == 'Yes') {
          this.isWorkInProgress = true;
          this.isOkEmd = false;
          this.isCrossEmd = true;
          this.payEMDBtn = true
          // }else if (this.consumerDetails.emdPaid == 'No') {
          //   this.isWorkInProgress = true;
          //   this.isOkEmd = true;
          //   this.isCrossEmd = false;
        } else if (this.consumerDetails.techSurvey == 'No') {
          // alert("ok222")
          this.isCrossTechSurvey = true;
          // this.isWorkInProOfferGen = false;//kousick
          this.isDisableDownldOffer = true;
          this.isWorkInProgressTechSur = false;
        }
        // }else {
        //   this.isOkEmd = true;
        //   // this.isCrossEmd = false;
        //   this.isWorkInProgress = false;
        //   this.payEMDBtn = false;
        //   this.isSubmitDoc = false;
        // }

        //alert(this.consumerDetails.emdPaid);
        //alert(this.consumerDetails.techSurvey);

        if (this.consumerDetails.techSurvey == 'Yes') {
          this.isOkTechSurvey = false;
          this.isCrossTechSurvey = true;
          //this.isOkQutationGenrt = false;//kousick
          this.isOkEmd = false;
          this.isWorkInProgress = true;
        } else if (this.consumerDetails.techSurvey == 'No') {
          this.isWorkInProgressTechSur = false;
          this.isOkTechSurvey = true;
          this.isWorkInProgressTechSur = true;
          this.isCrossQutationGenrt = false;
          //this.isOkQutationGenrt = true;//kousick
          this.isCrossTechSurvey = false;
          // this.isDisableDownldOffer = true;
        } else if (this.consumerDetails.techSurvey == 'No' && this.consumerDetails.emdPaid == 'No') {
          this.isWorkInProgressTechSur = true;
          this.isWorkInProgressTechSur = false;
          //this.isWorkInProOfferGen = false;//Kousick
        }

        if (this.consumerDetails.quotationGenerated == 'Yes') {
          this.isOkQutationGenrt = false;//kousick
          this.isOkEmd = false;
          this.isWorkInProgress = true;
          this.isDisableDownldOffer = false;
        }
        else {
          this.isWorkInProOfferGen = false
          this.isDisableDownldOffer = true
        }

        // if (this.consumerDetails.quotationGenerated == 'Yes') {
        //   this.isOkTechSurvey = false;
        //   this.isCrossTechSurvey = true;
        //   this.isOkQutationGenrt = false;
        //   this.isCrossQutationGenrt = true;
        //   this.isDisableDownldOffer = false;
        //   this.disableUpdateDocBtn = true;

        // } else if (this.consumerDetails.techSurvey == 'Yes') {
        //   this.isWorkInProOfferGen = false;
        // } else {
        //   //this.isWorkInProOfferGen = true;
        //   this.isCrossQutationGenrt = false;
        //   this.isOkQutationGenrt = true;
        //   this.isDisableDownldOffer = true;
        //   this.disableUpdateDocBtn = false;
        // }
        //  if(this.consumerDetails.quotationGenerated == 'Yes'){   

        //   this.isOkQutationGenrt = false;
        //   this.isCrossQutationGenrt = true;
        //   this.isDisableDownldOffer = false;
        //   this.disableUpdateDocBtn = true;
        //  }else{
        //    this.isOkQutationGenrt = true;
        //    this.isCrossQutationGenrt = false;
        //    this.isDisableDownldOffer = true;
        //    this.disableUpdateDocBtn = false;
        //  }

        if (this.consumerDetails.payByConsumer == 'Yes') {
          this.isOkPayment = false;
          this.isCrossPayment = true;
          this.isWorkInProConPay = true;
        } else if (this.consumerDetails.techSurvey == 'Yes') {
          this.isWorkInProConPay = false;
        } else {
          //this.isWorkInProOfferGen = true;
          this.isWorkInProConPay = false;
        }

        if (this.consumerDetails.workStartExecution == 'Yes') {
          this.isOkWorkStatus = false;
          this.isCrossWorkStatus = true;
        } else if (this.consumerDetails.workStartExecution == 'No') {
          this.isOkWorkStatus = true;
          this.isWorkInProWorkStart = false;
          //this.isWorkInProWorkStart = true;
        } else if (this.consumerDetails.payByConsumer == 'Yes') {
          this.isWorkInProWorkStart = false;
        } else {
          //this.isWorkInProOfferGen = true;
          this.isWorkInProWorkStart = false;
        }

        if (this.consumerDetails.onHold == 'Yes') {
          //alert(this.consumerDetails.onHold);
          //alert(this.isOkHoldDocmnt = true);
          //alert(this.isWarnHoldDocmnt = false);
          this.isOkHoldDocmnt = true;
          this.isWarnHoldDocmnt = false;
          this.disableUpdateDocBtn = false;
        } else {
          //this.disableUpdateDocBtn = tr;
          //this.isOkHoldDocmnt = false;
          // this.isWarnHoldDocmnt = true;
        }

        if (this.consumerDetails.workCompletedExecution == 'Yes') {
          this.isOkWorkExe = false;
          this.isCrossWorkExe = true;
        } else if (this.consumerDetails.workStartExecution == 'Yes') {
          this.isWorkInProWorkCom = false;
        } else {
          //this.isWorkInProOfferGen = true;
          this.isWorkInProWorkCom = false;
        }

        if (this.consumerDetails.energised == 'Yes') {
          this.isOkEnergised = false;
          this.isCrossEnergised = true;
        } else if (this.consumerDetails.workCompletedExecution == 'Yes') {
          this.isWorkInProEnersiged = false;
        } else {
          //this.isWorkInProOfferGen = true;
          this.isWorkInProEnersiged = false;
        }

        if (this.consumerDetails.quotationGenerated == 'Yes' && this.consumerDetails.payByConsumer == 'No') {
          this.payDemand = false;
        } else {
          this.payDemand = true;
        }

        if (this.consumerDetails.techSurvey == 'No' && this.consumerDetails.quotationGenerated == 'No' && this.consumerDetails.payByConsumer == 'No') {
          this.isHideSurvey = false;
        }
        else if (this.consumerDetails.techSurvey == 'Yes' && this.consumerDetails.quotationGenerated == 'Yes' && this.consumerDetails.payByConsumer == 'Yes') {
          this.isHideExecution = false;
        }
        else if (this.consumerDetails.techSurvey == 'No' && this.consumerDetails.quotationGenerated == 'Yes' && this.consumerDetails.payByConsumer == 'Yes') {
          this.isHideApplication = false;
        }
        else if (this.consumerDetails.techSurvey == 'No' && this.consumerDetails.quotationGenerated == 'No' && this.consumerDetails.payByConsumer == 'Yes') {
          this.isHideApplication = false;
          this.isHideExecutionStage = false;
        }
        else if (this.consumerDetails.techSurvey == 'Yes' && this.consumerDetails.quotationGenerated == 'No' && this.consumerDetails.payByConsumer == 'No') {
          this.isHideApplication = false;
        }
        else if (this.consumerDetails.techSurvey == 'Yes' && this.consumerDetails.quotationGenerated == 'No' && this.consumerDetails.payByConsumer == 'Yes') {
          this.isHideApplication = false;
        }
        else if (this.consumerDetails.techSurvey == 'Yes' && this.consumerDetails.quotationGenerated == 'Yes' && this.consumerDetails.payByConsumer == 'No') {
          this.isHideApplication = false;
        }
        else if (this.consumerDetails.techSurvey == 'No' && this.consumerDetails.quotationGenerated == 'Yes' && this.consumerDetails.payByConsumer == 'No') {
          this.isHideApplication = false;
        }

        if (this.consumerDetails.workStartExecution == 'Yes' && this.consumerDetails.workCompletedExecution == 'Yes' && this.consumerDetails.energised == 'Yes') {
          this.isHideExecution = false;
        }
        else if (this.consumerDetails.workStartExecution == 'No' && this.consumerDetails.workCompletedExecution == 'No' && this.consumerDetails.energised == 'No') {
          this.isRedCross = false;
        }
        else if (this.consumerDetails.workStartExecution == 'No' && this.consumerDetails.workCompletedExecution == 'Yes' && this.consumerDetails.energised == 'Yes') {
          this.isHideApplication = false;
        }
        else if (this.consumerDetails.workStartExecution == 'No' && this.consumerDetails.workCompletedExecution == 'No' && this.consumerDetails.energised == 'Yes') {
          this.isHideApplication = false;
        }
        else if (this.consumerDetails.workStartExecution == 'Yes' && this.consumerDetails.workCompletedExecution == 'No' && this.consumerDetails.energised == 'No') {
          this.isHideApplication = false;
        }

        else if (this.consumerDetails.workStartExecution == 'Yes' && this.consumerDetails.workCompletedExecution == 'No' && this.consumerDetails.energised == 'Yes') {
          this.isHideApplication = false;
        }
        else if (this.consumerDetails.workStartExecution == 'Yes' && this.consumerDetails.workCompletedExecution == 'Yes' && this.consumerDetails.energised == 'No') {
          this.isHideApplication = false;
        }
        else if (this.consumerDetails.workStartExecution == 'No' && this.consumerDetails.workCompletedExecution == 'Yes' && this.consumerDetails.energised == 'No') {
          this.isHideApplication = false;
        }

        self.isHideTable = false;
      },
      (error) => {
        self.errorMsg = error;
      });
  }

  onFileSelected(event) {
    this.isProof = false;
    this.selectedFile = <File>event.target.files[0];
  }

  onOwnerFileSelected(event) {
    this.isOwnership = false;
    this.selectedOwenershipFile = <File>event.target.files[0];
  }

  onAuthFileSelected(event) {
    this.isAuthorize = false;
    this.selectedAuthorizationDocFile = <File>event.target.files[0];
  }

  onUpload = function () {
    this.errorMsgIdentity = "";
    this.successMsgIdentity = "";
    this.isHidden = false;

    if (this.validateFileNameFor1and2() == false) {
      this.isProofOfIdentityMsg = false;
      this.duplicateMsgForIdentity = "Duplicate file";
      return;
    } else {
      this.isProofOfIdentityMsg = true;
    }

    if (this.validateFileNameFor1and3() == false) {
      this.isProofOfOwnershipMsg = false;
      this.duplicateMsgForIdentity = "Duplicate file";
      return;
    } else {
      this.isProofOfOwnershipMsg = true;
    }

    const fd = new FormData();
    fd.append('identificationDoc', this.selectedFile, this.selectedFile.name)

    this.serviceOn = true;
    this._http.post(AppSettings.IPCL_API + '/' + this.transcId + ',' + this.documentTypeModel.bpIdentificationCategory1 + ',' + this.documentTypeModel.other1 + ',' + this.documentTypeModel.card1 + AppSettings.IDENTIFICATNUPLOAD, fd)
      .subscribe(
        (data) => {
          this.proofOfUploadFile = data;
          if (this.proofOfUploadFile) {
            this.isProofOfIdentityMsg = false;
            this.isProofUpload = true;
            this.isHideSuccessMsgForIdentity = false;
            this.payEMDBtn = false;
            this.successMsgIdentity = " Proof of Identity successfully Uploaded.";
            this.verifiedId = true;

          } else if (!this.proofOfUploadFile) {
            this.isProofOfIdentityMsg = false;
            this.isProofUpload = false;
            this.isHideSuccessMsgForIdentity = true;
            this.payEMDBtn = true;
            this.errorMsgIdentity = "File does not uploaded properly";
          }
        },
        (error) => {
          this.isProofOfIdentityMsg = false;
          this.errorMsgIdentity = "File size is more than 1 MB";
        },
        () => {
          this.serviceOn = false;
        });
  }

  uploadOwnershipFile = function () {
    this.successMsgOwnershipMsg = "";
    this.errorMsgOwnershipMsg = "";
    // this.errorMsg = "";
    this.successMsg = "";
    this.isHiddenOwnerShip = false;

    if (this.validateFileNameFor1and2() == false) {
      this.isHideSuccessMsgForIdentity = true;
      this.isProofOfOwnershipMsg = false;
      this.isDuplicateMsgForOwnership = false;
      this.duplicateMsgForOwnership = "Duplicate file";
      return;
    } else {
      this.isProofOfOwnershipMsg = true;
    }

    if (this.validateFileNameFor2and3() == false) {
      this.isHideSuccessMsgForIdentity = true;
      this.isProofOfOwnershipMsg = false;
      this.isDuplicateMsgForOwnership = false;
      this.duplicateMsgForOwnership = "Duplicate file";
      return;
    } else {
      this.isProofOfOwnershipMsg = true;
    }

    const fd = new FormData();
    fd.append('ownershipDoc', this.selectedOwenershipFile, this.selectedOwenershipFile.name)

    this.serviceOn = true;
    this._http.post(AppSettings.IPCL_API + '/' + this.transcId + ',' + this.documentTypeModel.bpIdentificationCategory2 + ',' + this.documentTypeModel.other2 + ',' + this.documentTypeModel.card2 + AppSettings.OWENERSHIPUPLOAD, fd).subscribe(
      (data) => {
        this.ownershipFile = data;
        this.ownershipFile = data;

        if (this.ownershipFile) {
          this.isProofOfOwnershipMsg = false;
          this.isProofOfIdentityMsg = false;
          this.successMsgOwnershipMsg = "Proof of Ownership/Occupancy successfully Uploaded.";
          this.isDuplicateMsgForOwnership = true;
          this.isOwnershipUpload = true;
          this.verifiedOwn = true;
        } else if (!this.ownershipFile) {
          this.isProofOfOwnershipMsg = false;
          this.isProofOfIdentityMsg = false;
          this.errorMsgOwnershipMsg = "File does not uploaded properly";
          this.isDuplicateMsgForOwnership = true;
          this.isOwnershipUpload = false;
        }
      },
      (error) => {
        this.isProofOfOwnershipMsg = false;
        this.isProofOfIdentityMsg = false;
        this.errorMsgOwnershipMsg = "File size is more than 2 MB";
      },
      () => {
        this.serviceOn = false;
      })
  }

  uploadAuthorizationFile = function () {
    //this.errorMsg = "";
    this.successAuthMsg = "";
    this.errorAuthMsg = "";
    this.successMsg = "";
    this.isAuthorization = false;

    if (this.validateFileNameFor1and3() == false) {
      this.isHideSuccessMsgForIdentity = false;
      this.isAuthMsg = false;
      this.isDuplicateMsgForAuth = false;
      this.duplicateMsgForAuth = "Duplicate file";
      return;
    } else {
      this.isAuthMsg = true;
    }

    if (this.validateFileNameFor2and3() == false) {
      this.isHideSuccessMsgForIdentity = false;
      this.isAuthMsg = false;
      this.isDuplicateMsgForAuth = false;
      this.duplicateMsgForAuth = "Duplicate file";
      return;
    } else {
      this.isAuthMsg = true;
    }
    const fd = new FormData();
    fd.append('authorizationDoc', this.selectedAuthorizationDocFile, this.selectedAuthorizationDocFile.name)

    this.serviceOn = true;
    this._http.post(AppSettings.IPCL_API + '/' + this.transcId + ',' + this.documentTypeModel.bpIdentificationCategory3 + ',' + this.documentTypeModel.other3 + ',' + this.documentTypeModel.card3 + AppSettings.AUTHRISONUPLOAD, fd)
      .subscribe(
        (data) => {
          this.authorizationFile = data;

          if (this.authorizationFile) {
            this.isAuthMsg = false;
            this.isDuplicateMsgForAuth = true;
            this.successAuthMsg = "Authorization successfully Uploaded.";
            this.isAuthorizeUpload = true;
            this.isDisable = false;
          } else if (!this.authorizationFile) {
            this.isAuthMsg = false;
            this.isDuplicateMsgForAuth = true;
            this.errorAuthMsg = "File does not uploaded properly";
            this.isAuthorizeUpload = false;
            this.isDisable = true;
          }
        },
        (error) => {
          this.isAuthMsg = false;
          this.errorAuthMsg = "File size is more than 1 MB";
        },
        () => {
          this.serviceOn = false;
        });

  }

  validateFileNameFor1and2 = function () {
    if (this.selectedFile !== null && this.selectedOwenershipFile !== null) {
      if (this.selectedFile.name == this.selectedOwenershipFile.name) {
        return false;
      }
    }
  }

  validateFileNameFor2and3 = function () {
    if (this.selectedOwenershipFile !== null && this.selectedAuthorizationDocFile !== null) {
      if (this.selectedOwenershipFile.name == this.selectedAuthorizationDocFile.name) {
        return false;
      }
      return true;
    }
  }

  validateFileNameFor1and3 = function () {
    if (this.selectedAuthorizationDocFile !== null && this.selectedFile !== null) {
      if (this.selectedAuthorizationDocFile.name == this.selectedFile.name) {
        return;
      }
    }
  }

  checkValueProof = function (event: any) {
    if (event.target.checked) {
      this.isProofUpload = false;
    }
    else {
      this.isProofUpload = true;
    }
  }

  checkValueOthorization = function (event: any) {
    if (event.target.checked) {
      this.isOwnershipUpload = false;
    }
    else {
      this.isOwnershipUpload = true;
    }
  }

  checkValueAuthorize = function (event: any) {
    if (event.target.checked) {
      this.isAuthorizeUpload = false;
    }
    else {
      this.isAuthorizeUpload = true;
    }
  }

  retriveUplodedDocumentDetails = function () {
    var self = this;
    self.isHideIdentity = true;
    self.isHideOwnership = true;
    self.isHideAuthorization = true;
    //self.popupopen = false;
    self.successMsg = '';
    self.errorMsg = '';
    self.http.getTransaction(self.transcId).subscribe(
      (data: documentModel) => {
        this.transctionDetails = data;
        self.netAmount = data.netAmount;

        if (self.transctionDetails.identificationDoc == null) {
          // alert("111000");
          self.isHideIdentity = true;
          // self.isHideOwnership = false;
          // self.isHideAuthorization = false;
          //self.payEMDBtn = true;
          self.isSubmitDoc = false;
        }
        if (self.transctionDetails.ownershipDoc == null) {
          //alert("111111");
          self.isHideOwnership = true;
          // self.isHideOwnership = false;
          // self.isHideAuthorization = false;
          //self.payEMDBtn = true;
          self.isSubmitDoc = false;
        }
        if (self.transctionDetails.authorizationDoc == null) {
          // alert("111111");
          self.isHideAuthorization = true;
          // self.isHideOwnership = false;
          // self.isHideAuthorization = false;
          //self.payEMDBtn = true;
          self.isSubmitDoc = false;
        }
        if (self.transctionDetails.identificationDoc == "Proof of Identity"
          && self.transctionDetails.idDocStatus == "Rejected") {
          // alert("111111");
          self.isHideIdentity = false;
          // self.isHideOwnership = false;
          // self.isHideAuthorization = false;
          //self.payEMDBtn = true;
          self.isSubmitDoc = false;
        }

        if (self.transctionDetails.ownershipDoc == "Proof of Ownership"
          && self.transctionDetails.ownDocStatus == "Rejected") {
          //alert("22222");
          //self.isHideIdentity = false;
          self.isHideOwnership = false;
          //self.isHideAuthorization = false;
          //self.payEMDBtn = true;
          self.isSubmitDoc = false;
        }
        if (self.transctionDetails.authorizationDoc == "Authorization Documents"
          && self.transctionDetails.authDocStatus == "Rejected") {

          // alert("33333");
          //self.isHideIdentity = false;
          // self.isHideOwnership = false;
          self.isHideAuthorization = false;
          //self.payEMDBtn = true;
          self.isSubmitDoc = false;
        }
      },
      (error) => {
        self.errorMsg = error;
      });
  }

  saveDocument = function () {
    var self = this;
    self.popupopen = false;
    self.successMsg = '';
    self.errorMsg = '';
    self.retriveUplodedDocumentDetails();
  }

  openTermsCond() {
    this.isPaymentTermsConditn = false;
  }

  cancelTerms() {
    this.isPaymentTermsConditn = true;
  }

  payEmd = function () {
    var self = this;
    // this.isPaymentTermsConditn = false;

    var timestamp = new Date().getTime();
    var payEmdValue = 1;
    var payChannelId = 1;
    self.postPaymentData.applicationNumber = this.transcId;
    self.postPaymentData.paymentType = payEmdValue;
    self.postPaymentData.amount = self.payEmdAmnt;
    self.postPaymentData.paymentChannelId = payChannelId;

    self.http.postPayEmd(self.postPaymentData).subscribe(
      (data) => {
        self.initiatePaymentData = data.sourceSystem;
        window.location.href = AppSettings.BILLDESK_URL + "?msg=" + self.initiatePaymentData;
      },
      (error) => {
        self.errorMsg = error;
      },
      () => {
        self.successMsg = "";
        self.serviceOn = false;
      });
  }

  payNetEmd = function () {
    var self = this;
    var timestamp = new Date().getTime();
    var paymentType = 2;
    var payChannelId = 1;
    self.postPaymentData.applicationNumber = this.transcId;
    self.postPaymentData.paymentType = paymentType;
    self.postPaymentData.amount = this.payNetAmnt;
    //self.postPaymentData.amount = 0
    self.postPaymentData.paymentChannelId = payChannelId;

    if(!this.postPaymentData.amount || this.postPaymentData.amount < 1) {
      alert('amount 0')
			this.errorMsg = 'Can not proceed with bill amount zero(0).';
			return false;
		}
    
    self.http.postPayEmd(self.postPaymentData).subscribe(
      (data) => {
        self.initiatePaymentData = data.sourceSystem;
        window.location.href = AppSettings.BILLDESK_URL + "?msg=" + self.initiatePaymentData;
      },
      (error) => {
        self.errorMsg = error;
      },
      () => {
        self.successMsg = "";
        self.serviceOn = false;
      });
  }

  payWithRazorpayGateway() {
		
		var paymentType = 2;
		var payChannelId = 1;
		
		this.postPaymentData.paymentType = paymentType;
		this.postPaymentData.amount = this.payNetAmnt;
		this.postPaymentData.gateway = 2;
		this.postPaymentData.paymentChannelId = payChannelId;
		if(!this.postPaymentData.amount || this.postPaymentData.amount < 1) {
      alert('Can not proceed with bill amount zero(0)')
			this.errorMsg = 'Can not proceed with bill amount zero(0).';
			return false;
		}
		// initiate payment request
		this.http.postPayEmd(this.postPaymentData).subscribe((data) => {
			if(data['orderNo'] == null) { this.errorMsg = 'Could not proceed with gateway, please try gain later.'; return; }
			let orderNo: String = data['orderNo'];
			if(orderNo && orderNo.length > 0) {
				let options: any = {
					"key": Constants.rzp_key,
					"amount": (this.postPaymentData.amount * 100), /* amount to be passed as lowest currency unit */
					"name": "INDIA POWER",
					"description": "Payment",
					"image": "./assets/images/logo.jpg",
					"order_id": orderNo,
					"modal": {
						"escape": false
					},
					"prefill": {
						// "name": this.postPaymentData.consumerId,
						// "email": "gaurav.kumar@example.com",
						// "contact": "9999999999",
						// "method": 'card',
						// 'card[number]': finalObj.cardDetail.cardNumber,
						// 'card[expiry]': finalObj.cardDetail.cardExpDate,
						// 'card[cvv]': finalObj.cardDetail.cardCvv
					},
					// "notes": {
					//   "address": finalObj.addressDetail.address + ', ' + finalObj.addressDetail.landmark + ', ' + finalObj.addressDetail.city + ', ' + finalObj.addressDetail.state + '-' + finalObj.addressDetail.pincode
					// },
					// "theme": {
					// 	"color": "#0d4371"
					// }
				};
				options.handler = ((response) => {
					options['payment_response_id'] = response.razorpay_payment_id;
					this.handleRazorpayResponse(response);
				});
				options.modal.ondismiss = (() => {
					//   this.loginService.SetLoader = false;
				});
				let rzp = new this.http.nativeWindow.Razorpay(options);
				rzp.open();
			} else {
				this.errorMsg = 'Order could not be created, please try again later.';
			}

		}, (error) => {
			this.errorMsg = error;
		}, () => {
			this.successMsg = "";
			//this.serviceOn = false;
		});
		
	}

	handleRazorpayResponse(razorpayResponse) {
		this.http.postRazorpayResponse(razorpayResponse).subscribe((resp) => {
			if(resp['status'] === 'success') {
				this.successMsg = resp['paymentProcessingMessage'];
				setTimeout(() => { window.location.reload(); }, 5000);
			} else {
				this.errorMsg = resp['paymentProcessingMessage'];
			}
		});
	}

  downloadOffer = function () {
    var self = this;
    self.http.downloadIdentity(this.transcId).subscribe(
      (response: any) => {
        self.fileDetails = response;
        // get the response as blob, rename the file, and save  it
        const blob = response.blob();
        const file = new Blob([blob], {});
        const filename = 'Quotation_Offer_document';
        //FileSaver.saveAs(file, filename);
        var fileURL = URL.createObjectURL(blob);

        let newWindow = window.open(fileURL);
        if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
          this.downloadOfferBlocked = true;
          setTimeout(() => { this.downloadOfferBlocked = false; }, 3000);
        }
      },
      error => {
      });
  }

  onSelect() {
    this.hideTransID = false;
    this.hideSelectedTransID = true;
    this.getTransactionDetails(this.selectedTransactionId);
    this.retriveUplodedDocumentDetails();
  }

  closePopup = function () {
    var self = this;
    this.popupopen = true;
    this.getTransactionDetails(this.selectedTransactionId);
    self.retriveUplodedDocumentDetails();
  }

  payAmount = function (amount) {
    var self = this;
    var timestamp = new Date().getTime();

    var createdMsgStrngchcksum = AppSettings.BILLDESK_MARCH + "%7C" + this.transcId + timestamp + "%7CNA%7C" + amount + "%7CNA%7CNA%7CNA%7CINR%7CNA%7CR%7C" + AppSettings.BILLDESK_SEC + "%7CNA%7CNA%7CF%7CNA%7CNA%7CNA%7CNA%7CNA%7CNA%7CNA%7Chttp:fwdSlashfwdSlash13.126.3.149:9191fwdSlashpaymentfwdSlashpayment.jsp";
    var createdMsgStrng = AppSettings.BILLDESK_MARCH + "%7C" + this.transcId + timestamp + "%7CNA%7C" + amount + "%7CNA%7CNA%7CNA%7CINR%7CNA%7CR%7C" + AppSettings.BILLDESK_SEC + "%7CNA%7CNA%7CF%7CNA%7CNA%7CNA%7CNA%7CNA%7CNA%7CNA%7Chttp://13.126.3.149:9191/payment/payment.jsp";
    self.http.getChecksum(createdMsgStrngchcksum)
      .subscribe(
        (data) => {
          self.checkSumData = data;
        },
        (error) => {
          self.errorMsg = error;
          self.checkSumData = "";
        },
        () => {
          window.location.href = AppSettings.BILLDESK_URL + "?msg=" + createdMsgStrng + "%7C" + self.checkSumData.value;
        });
  }
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/transaction-details/transaction-details.component.ts